(function () {
  var instances = new WeakMap();
  var SELECTOR = '[data-section-type="custom-product-grid"]';
  var CONTAINER_SELECTOR = '.custom-product-grid__infinite-container';
  var TRIGGER_SELECTOR = '[data-infinite-trigger]';
  var LOAD_MORE_SELECTOR = '[data-load-more]';
  var ROOT_MARGIN = '0px 0px 400px 0px';

  var buildSectionUrl = function (nextUrl, sectionId) {
    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  var emitCollectionUpdated = function () {
    if (typeof window.emit === 'function') {
      window.emit('collection:updated');
      return;
    }

    document.dispatchEvent(new CustomEvent('collection:updated'));
  };

  var CustomProductGrid = function (section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.container = section.querySelector(CONTAINER_SELECTOR);
    this.trigger = section.querySelector(TRIGGER_SELECTOR);
    this.loading = false;
    this.observer = null;

    if (!this.container || !this.trigger || !this.getNextLink()) {
      return;
    }

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: ROOT_MARGIN,
    });
    this.observer.observe(this.trigger);
  };

  CustomProductGrid.prototype.getNextLink = function () {
    return this.trigger ? this.trigger.querySelector(LOAD_MORE_SELECTOR) : null;
  };

  CustomProductGrid.prototype.onIntersect = function (entries) {
    var entry = entries[0];

    if (!entry || !entry.isIntersecting || this.loading) {
      return;
    }

    this.loadMore();
  };

  CustomProductGrid.prototype.setLoading = function (isLoading) {
    this.loading = isLoading;
    this.section.classList.toggle('is-loading-more', isLoading);
  };

  CustomProductGrid.prototype.loadMore = function () {
    var nextLink = this.getNextLink();

    if (!nextLink || this.loading) {
      return;
    }

    var requestUrl = buildSectionUrl(nextLink.href, this.sectionId);

    this.setLoading(true);

    fetch(requestUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to load more products');
        }

        return response.text();
      })
      .then(this.onLoadSuccess.bind(this))
      .catch(function () {
        this.setLoading(false);
      }.bind(this));
  };

  CustomProductGrid.prototype.onLoadSuccess = function (html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nextSection = doc.querySelector(SELECTOR) || doc.body;
    var nextContainer = nextSection.querySelector(CONTAINER_SELECTOR);
    var nextTrigger = nextSection.querySelector(TRIGGER_SELECTOR);

    if (nextContainer && nextContainer.innerHTML.trim()) {
      this.container.insertAdjacentHTML('beforeend', nextContainer.innerHTML);
    }

    if (nextTrigger) {
      this.trigger.innerHTML = nextTrigger.innerHTML;
    } else {
      this.trigger.innerHTML = '';
    }

    this.setLoading(false);
    emitCollectionUpdated();

    if (!this.getNextLink()) {
      this.destroy();
      return;
    }

    // Re-observe in case the trigger moved after content was appended
    if (this.observer) {
      this.observer.unobserve(this.trigger);
      this.observer.observe(this.trigger);
    }
  };

  CustomProductGrid.prototype.destroy = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.setLoading(false);
  };

  var init = function (section) {
    destroy(section);
    instances.set(section, new CustomProductGrid(section));
  };

  var destroy = function (section) {
    var instance = instances.get(section);

    if (instance) {
      instance.destroy();
      instances.delete(section);
    }
  };

  var initAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll(SELECTOR).forEach(init);
  };

  var destroyAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll(SELECTOR).forEach(destroy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
